/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.Production {

    import fld = DismantlingItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class DismantlingItemsEditor extends _Ext.ItemGridEditor<DismantlingItemsRow> {


        protected getColumnsKey() { return "Production.DismantlingItems"; }
        protected getDialogType() { return DismantlingItemsDialog; }
        protected getLocalTextPrefix() { return DismantlingItemsRow.localTextPrefix; }
        protected form: DismantlingItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};

        // #region Variables 
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public LaborMarkup: number;
        public ExchangeRate: number;
        public DeptId: number;
        private NewLineNo: number;
        public canUpdate: number;
        private GenSKU = false;
        public DismantlingType: number;


        // #endregion


        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: true });
            this.slickGrid.setOptions({ rowHeight: 30 });

            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as DismantlingDialog).CalculateAmountandTax(this.view.getItems() );
                }
            })
        } 

        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns(); 
            //var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);
            //var wt = ctx => ColumnFormatter.WeightFormatter(ctx, this); 

            //var Department = Q.first(columns, x => x.field === fld.DepartmentId);
            //Department.referencedFields = [fld.DepartmentId];
            //Department.format = ctx => ColumnFormatter.selectFormatter(ctx, fld.DepartmentId, OMS.DepartmentMasterRow.getLookup(), this);

            //Q.first(columns, x => x.field === fld.Pieces).format = int;
            //Q.first(columns, x => x.field === fld.Weight).format = wt;

            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        // #endregion 

        //#region  ItemGrid Inline Editor

        // **** Onclick Event ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            //To Set Master Product Image
            //     PurchaseMasterDialog.image = item.ImageName;
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    if (this.canUpdate == 0) {
                        Q.alert("Voucher is ReadOnly can not Delete!!")
                    }
                    else {
                        //TODO: Validate for TransItemID in RefTransItemID in Stock
                        Q.confirm('Are you sure want to Delete? ', () => {

                            var id = this.id(item);
                            let refid: any;
                            TabAurous.Stock.StockItemService.CheckItemTransaction(
                                {
                                    RefTransId: item.TransId,
                                    RefTransItemId: item.TransItemId,
                                    Line_No: (item.Line_No),
                                    ProductId: (item.ProductId)
                                }
                                , response => {
                                    refid = response.Entities
                                }, { async: false })
                            if (refid != null && refid.length > 0) {
                                if (refid[0].TransId != null || refid[0].TransId > 0) {
                                    Q.alert("This Item has been used in transactions Can Not Delete!");
                                    return;
                                }
                            } else {
                                 
                                this.view.deleteItem(id);
                                this.element.trigger('dialogclose');
                            }
                        });
                    }
                    this.view.refresh();
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }

            if (target.hasClass('edit numeric')) {
                e.preventDefault();
                //TODO: Need to add System Parameter to enable disable blocking
                this.canUpdate = this.readOnly ? 0 : 1;
                var input = $(e.target);
                if (input != undefined) {
                    if (this.canUpdate == 0) {
                        //Check Editable
                        target.addClass('readonly');
                        target.blur();
                        Q.alert("Voucher is ReadOnly can not Edit!!")

                    }
                    else if (this.canUpdate == 1) {
                        target.removeClass('readonly');
                        var input = $(e.target);
                        var y = input.data();
                        if (y.field == "Weight" && item.ItemTypeId == 101) {
                            target.addClass('readonly');
                            target.blur();
                        }
                        else if (y.field == "UnitRate" && item.ItemTypeId == 101) {
                            target.addClass('readonly');
                            target.blur();
                        }
                        else if (y.field == "Pieces" && item.ItemTypeId == 104) {
                            target.addClass('readonly');
                            target.blur();
                        }
                    }

                }

                this.view.refresh();
            }

        }

        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.Weight || field === fld.Discount || field === fld.UnitRate) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0 && item.ItemTypeId == 101) {

                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.NetAmount * value;
                    item.Weight = (item.Weight / item.Pieces) * value;
                    item.DiamondPieces = (item.DiamondPieces / item.Pieces) * value;
                    item.DiamondWeight = (item.DiamondWeight / item.Pieces) * value;
                    item.DiamondAmount = (item.DiamondAmount / item.Pieces) * value;
                    item.StonePieces = (item.StonePieces / item.Pieces) * value;
                    item.StoneWeight = (item.StoneWeight / item.Pieces) * value;
                    item.StoneAmount = (item.StoneAmount / item.Pieces) * value;
                    item.OtherPieces = (item.OtherPieces / item.Pieces) * value;
                    item.OtherWeight = (item.OtherWeight / item.Pieces) * value;
                    item.OtherAmount = (item.OtherAmount / item.Pieces) * value;
                    item.NetWeight = (item.NetWeight / item.Pieces) * value;
                    item.BOMDetails.forEach(function (x) {
                        var Pieces = (x.Pieces / item.Pieces) * value;
                        var Weight = (x.Weight / item.Pieces) * value;
                        if (x.CalcOnId == 3) {
                            x.BomAmount = x.BomRate * Pieces;
                        }
                        else {
                            if (x.ItemTypeId == 104)
                                x.BomAmount = x.BomRate * Weight * x.Purity;
                            else
                                x.BomAmount = x.BomRate * Weight;
                        }
                        x.Pieces = Pieces;
                        x.Weight = Weight;
                    })
                    if (item.WstPer != null) {
                        item.WstWt = item.NetWeight * (item.WstPer / 100);
                    }
                }
                item[field] = value;
            }
            // **** Allow to Set Pcs to Zero for RM ****
            if (field === fld.Pieces && item.ItemTypeId != 101) {
                if (item.CalcOnId == 3) {
                    var labr = item.UnitLabour || 0;
                    var Net = ((item.UnitRate + labr) / item.Pieces) * value;
                    item.NetAmount = Net;
                    var Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount
                    item.GrossAmount = Net - Discount;
                    item.Weight = item.Pieces < value ? item.Weight * value : (item.Weight / item.Pieces) * value;
                    item.NetWeight = item.Pieces < value ? item.NetWeight * value : (item.NetWeight / item.Pieces) * value;
                    if (item.WstPer != null) {
                        item.WstWt = item.NetWeight * (item.WstPer / 100);
                    }
                    item[field] = value;
                }
                else {
                    item[field] = value;
                }

            }

            // **** Allow to Set Weight for RM ****
            if (field === fld.Weight && item.ItemTypeId != 101) {
                if (item.CalcOnId != 3) {
                    var labr = item.UnitLabour || 0;
                    var Net = ((item.UnitRate + labr) / item.Weight) * value;
                    item.NetAmount = Net;
                    var Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount
                    item.GrossAmount = Net - Discount;
                    item.NetWeight = value;
                    if (item.WstPer != null) {
                        item.WstWt = value * (item.WstPer / 100);
                    }
                    item[field] = value;
                }
                else {
                    item[field] = value;
                }

            }

            // **** Calculate Amount based on UnitRate and Weight or Pieces
            if (field === fld.UnitRate && item.ItemTypeId != 101) {
                if (item.CalcOnId != 3) {
                    var labr = item.UnitLabour || 0;
                    var Net = (item.Weight * value) + labr;
                    item.NetAmount = Net;
                    var Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount;
                    item.GrossAmount = Net - Discount;

                }


                if (item.CalcOnId == 3) {
                    var labr = item.UnitLabour || 0;
                    var Net = (item.Pieces * value) + labr;
                    item.NetAmount = Net;
                    var Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount;
                    item.GrossAmount = Net - Discount;

                }

                item[field] = value;
            }

            // *** Calculate Wastage ***
            if (field === fld.WstPer && value >= 0) {
                item.WstWt = item.NetWeight * (value / 100);
                item[field] = value;
            }

            // *** Calculate Discount ***
            if (field === fld.Discount && value >= 0) {
                item.GrossAmount = item.NetAmount - value;
                item.DiscountPer = (value / item.NetAmount) * 100;
                item[field] = value;

            }

            // *** Calculate Discount % ***
            if (field === fld.DiscountPer && value >= 0) {
                var Discount = (item.NetAmount * value) / 100
                item.GrossAmount = item.NetAmount - Discount;
                item.Discount = Discount;
                item[field] = value;

            }

            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;

            }

            this.view.updateItem(id, item);  
            this.view.refresh();

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }

        // #endregion


        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");
            // *** Add Select Button to Grid Editor ***
            buttons.push({
                title: "Select Products",
                cssClass: "stock-button",
                hotkey: "alt+k",
                hint: 'alt+k',
                onClick: () => {
                    var stockgrid = Common.StockSelectGrid;
                    var filters: _Ext.SelectGridFilters = {
                        FilterItems: 5
                    }
                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: stockgrid, multiple: true, title: "Select Items",
                        preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                    });
                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        var self = this;
                        var details = [];

                        // #region Items to Grid
                        //for (let value of selectedItems2)
                        selectedItems2.forEach(function (value: Stock.StockItemRow) {
                            var PrdId = value.ProductId;
                            var AtbId = value.AttributeId;
                            var bomdetails = [];
                            // #region Product Attributes
                            // **** Load & assign Attributes of Product using AtbID ****
                            let ATBDetails = value;
                            var SubCategoryId = ATBDetails.SubCategoryId;
                            var BrandId = ATBDetails.BrandId;
                            var SuperTypeId = ATBDetails.SuperTypeId;
                            var CollectionId = ATBDetails.CollectionId;
                            var LaborRate = 0;

                            value.BOMDetails.forEach(function (bomvalue) {
                                var bom: DismantlingBOMRow = {
                                    Attribute: bomvalue.Attribute,
                                    BomAmount: bomvalue.BomAmount,
                                    BOMAttributeId: bomvalue.BOMAttributeId,
                                    BomRate: bomvalue.BomRate,
                                    CalcOnId: bomvalue.CalcOnId,
                                    CalcOn: bomvalue.CalcOn,
                                    CertificateNo: bomvalue.CertificateNo,
                                    Pieces: bomvalue.Pieces,
                                    BOMProductId: bomvalue.BOMProductId == null ? bomvalue.BOMProductId : bomvalue.BOMProductId,
                                    ProductId: bomvalue.ProductId,
                                    ProductCode: bomvalue.ProductCode,
                                    ProductName: bomvalue.ProductName,
                                    RefTransBomId: bomvalue.StockBomId,
                                    Weight: bomvalue.Weight,
                                    ItemTypeId: bomvalue.ItemTypeId,
                                    ItemType: bomvalue.ItemType,
                                    Purity: bomvalue.Purity == null ? 0 : bomvalue.Purity,
                                    PureWeight: value.PureWeight,
                                    IsCustomerItem: value.IsCustomerItem
                                };
                                bomdetails.push(bom);
                            });

                            var bagno = FormatHelper.GetFormats("Bag");
                            if (value.BagNo == "" || value.BagNo == undefined) {
                                value.BagNo = bagno;
                            }
                            var purchase: DismantlingItemsRow = {
                                ProductId: PrdId,
                                AttributeId: AtbId,
                                Attribute: ATBDetails.Attribute,
                                Line_No: value.Line_No == undefined ? value.Line_No : value.Line_No,
                                SKU: value.SKU,
                                BagNo: value.BagNo,
                                Studded: 0,
                                DepartmentId: value.DepartmentId,
                                RefDepartmentId: value.DepartmentId,
                                ProductCode: value.ProductCode,
                                ProductName: value.ProductName,
                                ItemTypeId: ATBDetails.ItemTypeId,
                                CategoryId: ATBDetails.CategoryId,
                                ProductTypeId: ATBDetails.ProductTypeId,
                                SubCategoryId: SubCategoryId,
                                BrandId: BrandId,
                                SuperTypeId: SuperTypeId,
                                CollectionId: CollectionId,
                                UnitRate: value.Rate,
                                UnitLabour: LaborRate,
                                Pieces: value.Pieces,
                                Weight: value.Weight,
                                OtherPieces: value.OtherPieces,
                                OtherWeight: value.OtherWeight,
                                StonePieces: value.StonePieces,
                                StoneWeight: value.StoneWeight,
                                NetWeight: value.NetWeight,
                                NetAmount:0,
                                GrossAmount: 0,
                                DiamondPieces: value.DiamondPieces,
                                DiamondWeight: value.DiamondWeight,
                                CalcOnId: value.CalcOnId,
                                BOMDetails: bomdetails,
                                CompanyId: value.CompanyId,
                                CostMethodId: value.CostMethodId,
                                HSN: value.HSN == undefined ? value.HSN : value.HSN,
                                KaratId: ATBDetails.KaratId,
                                MetalColorId: ATBDetails.MetalColorId,
                                QualityId: ATBDetails.QualityId,
                                SieveId: ATBDetails.SieveId,
                                ShapeId: ATBDetails.ShapeId,
                                StoneColorId: ATBDetails.StoneColorId,
                                StoneSizeId: ATBDetails.StoneSizeId,
                                //StdPurity: PrdDetails.Purity,
                                ImageName: value.ImageName,
                                TaxCode: value.TaxCode,
                                StoneCutId: ATBDetails.StoneCutId,
                                StonePolishId: ATBDetails.StonePolishId,
                                StoneSymmetryId: ATBDetails.StoneSymmetryId,
                                StoneFluorescenceId: ATBDetails.StoneFluorescenceId,
                                StoneCuletId: ATBDetails.StoneCuletId,
                                StoneGirdleId: ATBDetails.StoneGirdleId,
                                StoneTable: ATBDetails.StoneTable,
                                StoneDepth: ATBDetails.StoneDepth,
                                CertificateNo: value.CertificateNo,
                                RefTransId: value.TransId,
                                RefTransItemId: value.TransItemId,
                                RefVoucherId: value.VoucherTypeId,
                                CalcUnitId: value.CalcOnId,
                                PureWeight: value.PureWeight,
                                Purity: value.Purity,
                                LotNo: value.LotNo,
                                HasBom: value.HasBom,
                                RefNo: value.RefNo,
                                
                            };

                            details.push(purchase);

                        });
                         
                        for (let Detail of details) {
                            Detail[this.getIdProperty()] = "`" + this.nextId++;
                            this.view.addItem(Detail);
                        }

                        // #endregion

                        // #endregion
                    }

                    pickerDialog.element.bind('dialogclose', () => {
                        this.element.trigger('dialogclose');

                    });


                    pickerDialog.dialogOpen();
                }
            });

            return buttons;
        }
        // #endregion


    }
}